import React, { useState, useEffect } from 'react';
// import Table from '../../../../../../common/components/Table';
import Table from './table';
import {
  InputLabel,
  Box,
  Grid,
} from '@material-ui/core';
import { containerAppConstants } from '../../../../../../constants';
import { configMessage } from '../../../../../../common/messages/config';
import useStyles from './style';

const authColumns = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    type: 'text',
    style: {
      marginLeft: 24,
      minWidth: '150px',
      maxWidth: '150px',
      overflowWrap: 'break-word',
      paddingTop: '5px',
      paddingBottom: '5px',
    },
  },
  {
    id: 'description',
    label: 'Description',
    align: 'left',
    type: 'text',
    style: {
      marginLeft: 24,
      minWidth: '150px',
      maxWidth: '150px',
      overflowWrap: 'break-word',
      paddingTop: '5px',
      paddingBottom: '5px',
    },
  },
  {
    id: 'checked',
    label: '',
    align: 'right',
    type: 'checkbox_without_icon',
    style: {
      marginLeft: 24,
      minWidth: '50px',
      maxWidth: '50px',
      overflowWrap: 'break-word',
      paddingTop: '8px',
      paddingBottom: '8px',
    },
  },
];

export default function (props) {
  const { appDetails, setAppDetails, authList, setModified , authError , setAuthError } = props;
  const classes = useStyles();
  const [authTableData, setAuthTableData] = useState([]);
  const [mAppSearchData, setMAppSearchData] = useState([]);
  const [mAapSearchQuery, setMAppSearchQuery] = useState('');

  useEffect(() => {
    const authentications = appDetails?.containerApp?.authentications?JSON.parse(appDetails.containerApp.authentications):[];
    const data = authList?.map((item) => {
      let selected = authentications.find((val) => {
        return val == item.id;
      });
      if (selected) {
        item = {
          ...item,
          checked: true,
        };
      }
      return item;
    }) || [];
    setAuthTableData(data);
  }, [authList]);

  const constructFinalPayload = (kind, data) => {
    let payload = { ...appDetails };
    let containerAppId = payload.containerApp?.id || "";
    if (kind === 'MICROAPP') {
      let temp = [...(payload?.containerApp?.authentications?JSON.parse(payload?.containerApp?.authentications):[])];
      if (data.checked) {
        temp.push('' + data.id  );   //, containerAppId
      } else {
        temp = JSON.parse(payload?.containerApp?.authentications).filter(
          (val) => parseInt(val) !== data.id
        );
      }
      payload = { ...payload, containerApp:{...payload.containerApp,authentications: JSON.stringify([...temp])} };
    }

    setAppDetails(payload);
  };

  const changePermissionTableValue = (checked, filter, index) => {
    let dataArr = [...authTableData];
    let temp = dataArr.map((e) => {
      if (e.id === filter.id) {
        const data = { ...e, checked: checked };
        return data;
      } else return e;
    });
    if (mAapSearchQuery !== '') {
      let tempA = mAppSearchData.map((e) =>
       e.id === filter.id
          ? { ...e, checked: checked }
          : e
      );
      setMAppSearchData(tempA);
    }
    setAuthTableData(temp);
    setModified(true);
  };

  const handleTableCheckBox = (e, row, index) => {
    setAuthError(false)
    if (e.target.checked) {
      changePermissionTableValue(true, { id: row.id }, index);
      constructFinalPayload('MICROAPP', {
        id: row.id,
        checked: true,
      });
    } else {
      changePermissionTableValue(false, { id: row.id }, index);
      constructFinalPayload('MICROAPP', {
        id: row.id,
        checked: false,
      });
    }
    setModified(true);
  };

  const handleMAppQueryChange = (value, column) => {
    if (authTableData.length > 0) {
      let filtered = authTableData.filter((item) => {
        return item[column['id']]?.toLowerCase()?.search(value?.toLowerCase()) !== -1;
      });
      setMAppSearchQuery(value);
      setMAppSearchData(filtered);
    }
    setModified(true);
  };

  const renderBfAppTree = (data = []) => {
    let finalData = [];
    if(data.length > 0){
      let authIds = data.map(e => { return e.id; });
      authIds = [ ...new Set(authIds)];
      finalData = authIds.map(e => {
        let childs = data.filter(f => (f.id === e && f.name != ''));
        let selected = appDetails.authentications?.find((item) => {
          return e == item.id;
        });
        return {
          businessFunctionId: e,
          businessFunctionName: childs[0]?.businessFunctionName || "",
          version: childs[0]?.version || "1.0",
          checked: selected ? true : false,
          child: childs
        }
      })
    }
    return finalData;
  }

  return (
    <Grid xs={12} container className={classes.appPermissionsContainer}>
      <Grid xs={9} className={classes.appBox} item>
        {/* <InputLabel className={classes.appTableBox}>
          {configMessage.T4597}
        </InputLabel> */}
        <small style={{ color: 'red', display: 'block', visibility:`${authError?"visible":"hidden"}` }}>
            Authentication not selected
          </small>
        <Box component='div' className={classes.tableBox}>
          <Table
            classes={classes}
            // tableData={renderBfAppTree(
            //   mAapSearchQuery ? mAppSearchData : microAppTableData || []
            // )}
            tableData={authTableData}
            tableColumns={authColumns || []}
            handleChange={(e, c) => handleMAppQueryChange(e, c)}
            handleCheckBox={handleTableCheckBox}
            screenType={'Project'}
            tableHeight='320px'
            rowMenuOptions={[]}
            headerMenuOptions={[]}
            handleMenuDropdown={props.handleVarMenuDropdown || []}
            checkDisable={props.checkDisable || []}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
